<template>
    <div id="sound-container">
        <select id="select" v-model="selectedSoundId">
            <option :value="null">Select sound...</option>
            <option v-for="sound in sounds" :value="sound.sound_id">
                {{ sound.filename }}
            </option>
        </select>
        <Player :source="selectedSound" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Player from './Player.vue';

export default {
    props: ['value'],
    emits: ['input'],
    components: { Player },
    data() {
        return {
            selectedSoundId: this.value ? this.value.sound_id : null,
            selectedSound: this.value
        }
    },
    computed: {
        ...mapGetters({
            sounds: 'allSounds'
        })
    },
    watch: {
        selectedSoundId: {
            handler(newSoundId) {
                if(!newSoundId) {
                    this.selectedSound = null
                    return
                }

                const sound = this.sounds.find(sound => sound.sound_id === newSoundId)
                this.selectedSound = {
                    url: `/upload/sounds/${sound.site_id}/${sound.filename}`,
                    duration: sound.length
                }
                this.$emit('input', sound)
            },
            immediate: true
        }
    },
    mounted() { 
        this.$store.dispatch('getSounds')
    }
};
</script>

<style scoped>
#sound-container {
    display: flex;
    background-color: #036;
    border-radius: 0.75rem;
    padding: 0.15rem 0.5rem;
}

#select {
    width: 45%;
    color: white;
    background-color: #036;
    border: none;
    border-radius: 0.75rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>